import React from 'react';
import type { SectionProps } from './Sidebar.types';

export const Section: React.FC<SectionProps> = () => null;
